const fonts = [
  { value: null, label: 'Selecionar fonte...' },
  { value: 'nCrypto1', label: 'Números 1' },
  { value: 'nCrypto2', label: 'Números 2' },
  { value: 'nCrypto3', label: 'Números 3' },
  { value: 'nCrypto4', label: 'Números 4' },
  { value: 'nCrypto10', label: 'Números 10' },
  { value: 'nCrypto11', label: 'Números 11' },
  { value: 'Crypto1', label: 'Símbolos 1' },
  { value: 'Crypto2', label: 'Símbolos 2' },
  { value: 'Crypto3', label: 'Símbolos 3' },
  { value: 'Crypto4', label: 'Símbolos 4' },
  { value: 'Font-crypto-1', label: 'Font Crypto 1' },
  { value: 'Font-crypto-2', label: 'Font Crypto 2' },
  { value: 'Font-crypto-3', label: 'Font Crypto 3' },
  { value: 'Font-crypto-4', label: 'Font Crypto 4' },
  { value: 'Font-crypto-5', label: 'Font Crypto 5' },
  { value: 'Font-crypto-6', label: 'Font Crypto 6' },
  { value: 'Font-crypto-7', label: 'Font Crypto 7' },
  { value: 'Font-crypto-8', label: 'Font Crypto 8' },
  { value: 'Font-crypto-9', label: 'Font Crypto 9' },
  { value: 'Font-crypto-10', label: 'Font Crypto 10' },
  { value: 'Font-crypto-11', label: 'Font Crypto 11' },
  { value: 'Font-crypto-12', label: 'Font Crypto 12' },
  { value: 'Font-crypto-13', label: 'Font Crypto 13' },
  { value: 'Font-crypto-14', label: 'Font Crypto 14' },
  { value: 'Font-crypto-15', label: 'Font Crypto 15' },
  { value: 'Font-crypto-16', label: 'Font Crypto 16' },
  { value: 'Font-crypto-17', label: 'Font Crypto 17' },
  { value: 'Font-crypto-18', label: 'Font Crypto 18' },
  { value: 'Font-crypto-19', label: 'Font Crypto 19' },
  { value: 'Font-crypto-20', label: 'Font Crypto 20' },
  { value: 'Font-crypto-21', label: 'Font Crypto 21' },
  { value: 'Font-crypto-22', label: 'Font Crypto 22' },
  { value: 'Font-crypto-23', label: 'Font Crypto 23' },
  { value: 'Font-crypto-24', label: 'Font Crypto 24' },
  { value: 'Font-crypto-25', label: 'Font Crypto 25' },
  { value: 'Font-crypto-26', label: 'Font Crypto 26' },
  { value: 'Font-crypto-27', label: 'Font Crypto 27' },
  { value: 'Font-crypto-28', label: 'Font Crypto 28' },
  { value: 'Font-crypto-29', label: 'Font Crypto 29' },
  { value: 'Font-crypto-30', label: 'Font Crypto 30' },
];

export default fonts;
